import { useState, useEffect } from 'react';
import i18n from '../i18n';
import { LANGUAGE_KEY } from '../i18n';

export function useLanguage() {
const [language, setLanguageState] = useState<string>(() => {
  const stored = localStorage.getItem(LANGUAGE_KEY);
  if (stored) return stored;
  return navigator.language?.startsWith('pl') ? 'pl' : 'en';
});

  useEffect(() => {
    localStorage.setItem(LANGUAGE_KEY, language);
    i18n.changeLanguage(language);
  }, [language]);

  const setLanguage = (lang: string) => {
    setLanguageState(lang);
  };

  return { language, setLanguage };
}
